import { gql } from 'graphql-request'

export const FETCH_CANDIDATE_PROFILE = gql`
  query fetchCandidateProfile($candidateId: ID!) {
    candidateProfile(id: $candidateId) {
      id
      preferredCities {
        countryName
      }
      regionalCitizenships {
        id
        citizenshipStatus
        countryName
        countryIso2Code
        description
        permitType
      }
    }
  }
`

export const UPDATE_CANDIDATE_REGIONAL_CITIZENSHIP = gql`
  mutation mutateRegionalCitizenship($input: UpdateCandidateRegionalCitizenshipInput!) {
    updateCandidateRegionalCitizenship(input: $input) {
      regionalCitizenship {
        id
        citizenshipStatus
      }
    }
  }
`
